module.exports = __webpack_public_path__ + "img/dnatestinganaheim.065452e3.png";